import { fabric } from "fabric";
export const gradientCheck = (
  canvas,
  selectedColor,
  selectedStrokeColor,
  setSelectedColor,
  setSelectedStrokeColor
) => {
  if (canvas) {
    console.log("Canvas found, updating objects...");

    const activeObjects = canvas._objects;

    activeObjects.forEach((obj) => {
      // Skip brush strokes (fabric.Path from free drawing)
      if (obj.type === "path") {
        console.log("Skip brush strokes");
        return;
      }
      console.log("Before update:", obj);

      let fillValue = selectedColor;
      let strokeValue = selectedStrokeColor;

      // Check for linear gradient
      if (/linear-gradient/.test(selectedColor)) {
        fillValue = createLinearGradient(selectedColor);
      }

      // Check for radial gradient
      if (/radial-gradient/.test(selectedColor)) {
        fillValue = createRadialGradient(selectedColor);
      }

      // Similarly for stroke
      if (/linear-gradient/.test(selectedStrokeColor)) {
        strokeValue = createLinearGradient(selectedStrokeColor);
      }

      if (/radial-gradient/.test(selectedStrokeColor)) {
        strokeValue = createRadialGradient(selectedStrokeColor);
      }

      // Set the properties
      obj.set({
        fill: fillValue,
        stroke: strokeValue,
        visible: true, // Ensure visibility
      });

      console.log("After update:", obj);
    });

    canvas.renderAll(); // Force re-render the canvas
  }
};

export const createLinearGradient = (gradientStr) => {
  const parsedGradient = parseGradient(gradientStr);

  const angle = parsedGradient.angle;
  const coords = calculateGradientCoords(angle);

  return new fabric.Gradient({
    type: "linear",
    gradientUnits: "percentage",
    coords: coords,
    colorStops: parsedGradient.stops,
  });
};

export const createRadialGradient = (gradientStr) => {
  const parsedGradient = parseGradient(gradientStr);

  return new fabric.Gradient({
    type: "radial",
    gradientUnits: "percentage",
    coords: {
      x1: 0.5,
      y1: 0.5,
      r1: 0,
      x2: 0.5,
      y2: 0.5,
      r2: 0.5,
    },
    colorStops: parsedGradient.stops,
  });
};

const parseGradient = (gradientStr) => {
  const stops = [];
  let angle = 0;

  // Normalize the gradient string to lowercase for consistent parsing
  const normalizedGradientStr = gradientStr.toLowerCase();

  // Match the angle (e.g., "90deg")
  const angleMatch = normalizedGradientStr.match(/(\d+)deg/);
  if (angleMatch) {
    angle = parseFloat(angleMatch[1]);
  }

  // Match all color stops (e.g., "rgba(255, 0, 0, 1) 50%")
  const gradientParts = normalizedGradientStr.match(
    /rgba?\([\d\s.,]+\)\s*\d+%?/g
  );

  if (!gradientParts) {
    console.warn("No gradient parts found in:", gradientStr);
    return { angle, stops }; // Return empty stops to avoid crashes
  }

  gradientParts.forEach((part) => {
    // Split color and position
    const match = part.match(/(rgba?\([\d\s.,]+\))\s*(\d+%?)/);
    if (match) {
      const color = match[1].trim();
      const position = match[2].trim().replace("%", "");
      stops.push({
        offset: parseFloat(position) / 100,
        color: color,
      });
    } else {
      console.warn("Invalid gradient part skipped:", part);
    }
  });

  return { angle, stops };
};

const calculateGradientCoords = (angle) => {
  const angleRad = (angle * Math.PI) / 180;

  let x1 = 0,
    y1 = 0,
    x2 = 1,
    y2 = 0;

  if (angle !== 0) {
    x1 = 0.5 + 0.5 * Math.cos(angleRad + Math.PI);
    y1 = 0.5 + 0.5 * Math.sin(angleRad + Math.PI);
    x2 = 0.5 + 0.5 * Math.cos(angleRad);
    y2 = 0.5 + 0.5 * Math.sin(angleRad);
  }

  return { x1, y1, x2, y2 };
};
